import { render, staticRenderFns } from "./ReflectionCheckboxContainer.vue?vue&type=template&id=60530917&scoped=true&"
import script from "./ReflectionCheckboxContainer.vue?vue&type=script&lang=js&"
export * from "./ReflectionCheckboxContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60530917",
  null
  
)

export default component.exports